import { useMemo } from 'react';
import { boardFileToDoc, SceneStore, type BoardFile } from '@os/doc';
import { thumbnailPlan, worldObjects } from '../media/thumbnail';
import { ThumbOpsSvg } from '../media/ThumbOpsSvg';

/** A system template drawn as the 640 × 400 board preview, in SVG (plan P10 Ruling 8). */
export function TemplatePreview({ file }: { file: BoardFile | null }) {
  const ops = useMemo(() => (file ? thumbnailPlan(worldObjects(new SceneStore(boardFileToDoc(file)))) : []), [file]);
  return <ThumbOpsSvg ops={ops} className="aspect-[16/10] h-auto w-full rounded-md border border-border" />;
}
